"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ANALYTICS_CONSENT_EVENT, ANALYTICS_CONSENT_KEY } from "@/components/umami-analytics";

export function AnalyticsPreferences() {
  const [consent, setConsent] = useState<string | null>(null);
  useEffect(() => {
    const sync = () => setConsent(window.localStorage.getItem(ANALYTICS_CONSENT_KEY));
    sync();
    window.addEventListener(ANALYTICS_CONSENT_EVENT, sync);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, sync);
  }, []);
  function choose(value: "accepted" | "declined") {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    window.localStorage.setItem("elenails_cookie_notice_seen", "1");
    window.dispatchEvent(new Event(ANALYTICS_CONSENT_EVENT));
    setConsent(value);
  }
  return <div className="analytics-preferences" aria-live="polite"><strong>Votre choix actuel : {consent === "accepted" ? "statistiques autorisées" : consent === "declined" ? "sans statistiques" : "pas encore défini"}.</strong><div><Button type="button" size="sm" variant="outline" onClick={() => choose("declined")}>Refuser les statistiques</Button><Button type="button" size="sm" onClick={() => choose("accepted")}>Autoriser les statistiques</Button></div></div>;
}
